import {Injectable} from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import {map} from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class UploadService {

  constructor(private http: HttpClient) {
  }

  private baseURI = '/tmssserver/api/file';

  postFile(file: File, processName: string): Observable<any> {
    // console.log('File Name: ' + file.name);
    const endpoint = 'tmssserver/api/public/file';
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('processName', processName);

    const req = new HttpRequest('POST', this.baseURI, formData, {
      reportProgress: true,
      responseType: 'text',
    });

    return this.http.request(req).pipe(
        map(event => this.getEventMessage(event, file)),
    );
  }

  postFileWithDetails(file: File, processName: string, documentType: string, documentName: string, organizationId: string): Observable<any> {
    // console.log('File Name: ' + file.name);
    const endpoint = 'tmssserver/api/public/file';
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('processName', processName);
    formData.append('documentType',documentType);
    formData.append('documentName',documentName);
    formData.append('organizationId',organizationId);
    const req = new HttpRequest('POST', this.baseURI + '/uploadFileWithDetails', formData, {
      reportProgress: true,
      responseType: 'text',
    });
    return this.http.request(req).pipe(
        map(event => this.getEventMessage(event, file)),
    );
  }

  postDocWithDetails(file: File, scacCode: string, documentType: string, documentName: string): Observable<any> {
    // console.log('File Name: ' + file.name);
    const endpoint = 'tmssserver/api/public/file/documentWithDetails';
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('scacCode', scacCode);
    formData.append('documentType',documentType);
    formData.append('documentName',documentName);
    const req = new HttpRequest('POST', this.baseURI + '/documentWithDetails', formData, {
      reportProgress: true,
      responseType: 'text',
    });

    return this.http.request(req).pipe(
        map(event => this.getEventMessage(event, file)),
    );
  }

  postDoc(file: File, scacCode: string): Observable<any> {
    // console.log('File Name: ' + file.name);
    const endpoint = 'tmssserver/api/public/file/document';
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('scacCode', scacCode);

    const req = new HttpRequest('POST', this.baseURI + "/document", formData, {
      reportProgress: true,
      responseType: 'text',
    });

    return this.http.request(req).pipe(
        map(event => this.getEventMessage(event, file)),
    );
  }

  postImage(file: File, busType: string): Observable<any> {
    // console.log('File Name: ' + file.name);
    const imageURI = this.baseURI + "/image";
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('busType', busType);

    const req = new HttpRequest('POST', imageURI, formData, {
      reportProgress: true,
      responseType: 'text',
    });

    return this.http.request(req).pipe(
        map(event => this.getEventMessage(event, file)),
    );
  }


  /** Return distinct message for sent, upload progress, & response events */
  private getEventMessage(event: HttpEvent<any>, file: File) {
    switch (event.type) {
      case HttpEventType.Sent:
        return {status: 'uploading', message: 0};
      case HttpEventType.UploadProgress:
        const percentDone = Math.round(100 * event.loaded / event.total);
        return {status: 'uploading', message: percentDone};
      case HttpEventType.Response:
        return {
          status: 'done',
          message: file.name + ' has been successfully uploaded. You will be notified via email once it has been processed and validated.'
        };
      default:
        return {status: 'uploading', message: 100};
    }
  }
}
